__turbopack_context__.v({
  "arrow": "next-popover-module-scss-module__llVxLG__arrow",
  "arrow--tooltip": "next-popover-module-scss-module__llVxLG__arrow--tooltip",
  "popover": "next-popover-module-scss-module__llVxLG__popover",
  "popover--tooltip": "next-popover-module-scss-module__llVxLG__popover--tooltip",
  "popover__inner": "next-popover-module-scss-module__llVxLG__popover__inner",
});
